import { useState } from "react";
import { db } from "../../db";
import {
  Btn, Modal, Field, Inp, Sel, Txta, FormRow, Empty,
  BlockHead, Chips, Selo, ExpandTable,
} from "../../components/primitives";
import { INSTANCIAS_CONHECIDAS, ESPECIALIDADES_MEDICAS, MENSAGENS_PADRAO } from "./constants";

function ComboInp({ listId, value, onChange, placeholder, options }) {
  return (
    <>
      <input
        list={listId}
        className="input"
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="off"
        style={{ width: "100%" }}
      />
      <datalist id={listId}>
        {options.map((o) =>
          typeof o === "string"
            ? <option key={o} value={o} />
            : <option key={o.value} value={o.value}>{o.label}</option>
        )}
      </datalist>
    </>
  );
}

export const STATUS_CFG = {
  rascunho:        { label: "Rascunho",           tone: "off",  bg: "var(--surface-3)",     color: "var(--muted)" },
  homologacao:     { label: "Homologação",        tone: "warn", bg: "var(--warn-soft)",    color: "var(--warn-ink)" },
  implantacao:     { label: "Implantação",        tone: "info", bg: "var(--cat-violet-soft)", color: "var(--cat-violet-ink)" },
  pronto_producao: { label: "Pronto p/ Produção", tone: "gold", bg: "var(--cat-teal-soft)",   color: "var(--cat-teal-ink)" },
  producao:        { label: "Em Produção",        tone: "ok",   bg: "var(--success-soft)", color: "var(--success-ink)" },
  pausado:         { label: "Pausado",            tone: "bad",  bg: "var(--danger-soft)",  color: "var(--danger-ink)" },
};

export const AMBIENTE_CFG = {
  lab:      { label: "LAB",      tone: "info", bg: "var(--info-soft)",       color: "var(--info-ink)" },
  producao: { label: "Produção", tone: "ok",   bg: "var(--success-soft)",    color: "var(--success-ink)" },
  template: { label: "Template", tone: "off",  bg: "var(--cat-violet-soft)", color: "var(--cat-violet-ink)" },
};

const STATUSES  = ["rascunho", "homologacao", "implantacao", "pronto_producao", "producao", "pausado"];
const AMBIENTES = ["lab", "producao", "template"];
const TEMPLATES = ["fluxomed-v1", "fluxomed-v1.1", "fluxomed-v2"];

function slugify(str) {
  return str
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .toLowerCase().trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

function NovoClienteModal({ onClose, onSave }) {
  const [f, setF] = useState({
    nome: "", slug: "", status: "rascunho", ambiente: "lab",
    origem_template: "fluxomed-v1", instancia_evolution: "",
    medico_nome: "", medico_especialidade: "", medico_crm: "",
    secretaria_nome: "", secretaria_whatsapp: "", notas: "",
  });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  function handleNome(v) {
    up("nome", v);
    if (!f.slug || f.slug === slugify(f.nome)) {
      up("slug", slugify(v));
    }
  }

  async function save() {
    if (!f.nome.trim() || !f.slug.trim()) { setErr("Nome e slug são obrigatórios."); return; }
    setSaving(true);
    setErr("");
    try {
      await onSave(f);
    } catch (e) {
      setErr(e.message || "Erro ao salvar.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal title="Novo cliente FluxoMed" onClose={onClose} width={520}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

        <Field label="Nome do cliente">
          <Inp value={f.nome} onChange={(e) => handleNome(e.target.value)}
            placeholder="Ex: Dr. Victor Couto" autoFocus />
        </Field>

        <Field label="Slug (identificador único)">
          <Inp value={f.slug} onChange={(e) => up("slug", slugify(e.target.value))}
            placeholder="Ex: dr-victor-couto" />
        </Field>

        <FormRow>
          <Field label="Status" half>
            <Sel value={f.status} onChange={(e) => up("status", e.target.value)}>
              {STATUSES.map((s) => <option key={s} value={s}>{STATUS_CFG[s].label}</option>)}
            </Sel>
          </Field>
          <Field label="Ambiente" half>
            <Sel value={f.ambiente} onChange={(e) => up("ambiente", e.target.value)}>
              {AMBIENTES.map((a) => <option key={a} value={a}>{AMBIENTE_CFG[a].label}</option>)}
            </Sel>
          </Field>
        </FormRow>

        <FormRow>
          <Field label="Template de origem" half>
            <Sel value={f.origem_template} onChange={(e) => up("origem_template", e.target.value)}>
              {TEMPLATES.map((t) => <option key={t} value={t}>{t}</option>)}
              <option value="">Personalizado</option>
            </Sel>
          </Field>
          <Field label="Instância Evolution API" half>
            <ComboInp
              listId="instancias-modal"
              value={f.instancia_evolution}
              onChange={(e) => up("instancia_evolution", e.target.value)}
              placeholder="Ex: dr-victor"
              options={INSTANCIAS_CONHECIDAS}
            />
          </Field>
        </FormRow>

        <div style={{ borderTop: "1px solid var(--line)", paddingTop: 12 }}>
          <div className="eyebrow" style={{ marginBottom: 10 }}>
            Médico
          </div>
          <FormRow>
            <Field label="Nome" half>
              <Inp value={f.medico_nome} onChange={(e) => up("medico_nome", e.target.value)}
                placeholder="Ex: Dr. Victor Couto" />
            </Field>
            <Field label="Especialidade" half>
              <ComboInp
                listId="especialidades-modal"
                value={f.medico_especialidade}
                onChange={(e) => up("medico_especialidade", e.target.value)}
                placeholder="Ex: Dermatologia"
                options={ESPECIALIDADES_MEDICAS}
              />
            </Field>
          </FormRow>
        </div>

        <div style={{ borderTop: "1px solid var(--line)", paddingTop: 12 }}>
          <div className="eyebrow" style={{ marginBottom: 10 }}>
            Secretária
          </div>
          <FormRow>
            <Field label="Nome" half>
              <Inp value={f.secretaria_nome} onChange={(e) => up("secretaria_nome", e.target.value)}
                placeholder="Ex: Carol" />
            </Field>
            <Field label="WhatsApp" half>
              <Inp value={f.secretaria_whatsapp} onChange={(e) => up("secretaria_whatsapp", e.target.value)}
                placeholder="Ex: 557191234567" />
            </Field>
          </FormRow>
        </div>

        <Field label="Notas">
          <Txta rows={2} value={f.notas} onChange={(e) => up("notas", e.target.value)}
            placeholder="Observações gerais sobre a implantação..." />
        </Field>

        {err && <div className="alert-line bad" style={{ marginBottom: 0 }}>{err}</div>}

        <Btn variant="primary" full onClick={save} disabled={saving || !f.nome.trim()}>
          {saving ? "Criando..." : "Criar cliente"}
        </Btn>
      </div>
    </Modal>
  );
}

export function FluxoMedClientes({ clientes, onOpen, onCreated }) {
  const [search, setSearch]         = useState("");
  const [filterStatus, setFilterStatus]   = useState("todos");
  const [filterAmbiente, setFilterAmbiente] = useState("todos");
  const [showNew, setShowNew]       = useState(false);
  const [saving, setSaving]         = useState(false);

  const filtered = clientes.filter((c) => {
    const q = search.toLowerCase();
    const matchSearch = !q ||
      c.nome.toLowerCase().includes(q) ||
      (c.slug || "").toLowerCase().includes(q) ||
      (c.medico_nome || "").toLowerCase().includes(q) ||
      (c.instancia_evolution || "").toLowerCase().includes(q);
    const matchStatus  = filterStatus  === "todos" || c.status  === filterStatus;
    const matchAmbiente = filterAmbiente === "todos" || c.ambiente === filterAmbiente;
    return matchSearch && matchStatus && matchAmbiente;
  });

  async function handleCreate(data) {
    setSaving(true);
    try {
      const [created] = await db("fluxomed_clientes", "POST", data);
      // Seed mensagens padrão automaticamente
      await Promise.all(
        Object.entries(MENSAGENS_PADRAO).map(([tipo, conteudo]) =>
          db("fluxomed_mensagens", "POST", { cliente_id: created.id, tipo, conteudo })
        )
      );
      // Registrar evento de criação
      db("fluxomed_historico", "POST", {
        cliente_id: created.id,
        evento: "cliente_criado",
        descricao: `Cliente ${created.nome} criado (${created.ambiente} · ${created.origem_template || "personalizado"})`,
      }).catch(() => {});
      await onCreated(created.id);
    } finally {
      setSaving(false);
      setShowNew(false);
    }
  }

  function fmtData(ts) {
    if (!ts) return "";
    return new Date(ts).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
  }

  return (
    <div className="view" style={{ paddingTop: 0 }}>
      <BlockHead title="Clientes" sub="Configuração dos bots de pré-agendamento. Uma linha por cliente; clique para abrir a ficha.">
        <Btn sm variant="primary" onClick={() => setShowNew(true)}>+ Novo cliente</Btn>
      </BlockHead>

      {/* ── Filtros ────────────────────────────────────────── */}
      <div className="tab-bar">
        <Chips
          label="Filtrar por situação"
          active={filterStatus}
          onChange={setFilterStatus}
          items={[
            { id: "todos", label: "Todos", count: clientes.length },
            ...STATUSES
              .map((s) => ({ id: s, label: STATUS_CFG[s].label, count: clientes.filter((c) => c.status === s).length }))
              .filter((it) => it.count > 0 || it.id === filterStatus),
          ]}
        />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", flex: "1 1 320px", justifyContent: "flex-end" }}>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar cliente, médico, slug, instância..."
            className="input"
            style={{ flex: "1 1 200px", minWidth: 160, maxWidth: 320 }}
          />
          <div className="select-wrap" style={{ flex: "0 0 160px" }}>
            <select
              className="select"
              value={filterAmbiente}
              onChange={(e) => setFilterAmbiente(e.target.value)}
            >
              <option value="todos">Todos os ambientes</option>
              {AMBIENTES.map((a) => (
                <option key={a} value={a}>{AMBIENTE_CFG[a].label}</option>
              ))}
            </select>
            <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: "var(--faint)", fontSize: 10 }}>▾</span>
          </div>
          {(search || filterStatus !== "todos" || filterAmbiente !== "todos") && (
            <Btn sm variant="ghost" onClick={() => { setSearch(""); setFilterStatus("todos"); setFilterAmbiente("todos"); }}>
              Limpar
            </Btn>
          )}
        </div>
      </div>

      {/* ── Lista ──────────────────────────────────────────── */}
      {clientes.length === 0 ? (
        <Empty icon="⚕" text="Nenhum cliente FluxoMed cadastrado. Clique em + Novo cliente para começar." />
      ) : (
        <ExpandTable
          minWidth={720}
          rows={filtered}
          onOpen={(c) => onOpen(c.id)}
          empty="Nenhum cliente encontrado com os filtros aplicados."
          columns={[
            { key: "nome", label: "Cliente", render: (c) => (
              <div><div className="name">{c.nome}</div><div className="sub" style={{ fontFamily: "var(--font-data)" }}>{c.slug}</div></div>
            ) },
            { key: "medico", label: "Médico", render: (c) => c.medico_nome
              ? <div><div>{c.medico_nome}</div>{c.medico_especialidade && <div className="sub">{c.medico_especialidade}</div>}</div>
              : <span className="sub">—</span> },
            { key: "status", label: "Situação", render: (c) => {
              const sCfg = STATUS_CFG[c.status] || STATUS_CFG.rascunho;
              return <Selo tone={sCfg.tone}>{sCfg.label}</Selo>;
            } },
            { key: "amb", label: "Ambiente", render: (c) => {
              const aCfg = AMBIENTE_CFG[c.ambiente] || AMBIENTE_CFG.lab;
              return <Selo tone={aCfg.tone} dot={false}>{aCfg.label}</Selo>;
            } },
            { key: "data", label: "Desde", align: "right", render: (c) => <span className="sub">{fmtData(c.created_at)}</span> },
          ]}
        />
      )}

      {/* ── Modais ─────────────────────────────────────────── */}
      {showNew && (
        <NovoClienteModal
          onClose={() => setShowNew(false)}
          onSave={handleCreate}
        />
      )}
    </div>
  );
}
